export enum MultiVinVisibilityScope {
  FullVisibility = 'platform_full',
  InventoryOnly = 'inventory_only'
}

export interface GeneratedLeaseOfferDraft {
  paymentAmount: number | null;
  moneyDown: number | null;
  percentageDown: number | null;
  term: number | null;
  annualMileage: number | null;
  additionalText: string | null;
  isCustom: boolean;
}

export interface GeneratedFinanceOfferDraft {
  paymentAmount: number | null;
  moneyDown: number | null;
  percentageDown: number | null;
  apr: number | null;
  term: number | null;
  additionalText: string | null;
  isCustom: boolean;
}

export interface GeneratedAprOfferDraft {
  apr: number | null;
  term: number | null;
  additionalText: string | null;
  useDefaultSettings: boolean;
}

export interface GeneratedOfferSetDraft {
  multiVinVisibility: MultiVinVisibilityScope;
  lease: GeneratedLeaseOfferDraft;
  alternateLease: GeneratedLeaseOfferDraft;
  finance: GeneratedFinanceOfferDraft;
  promotionalApr: GeneratedAprOfferDraft;
}
